/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
require('../vendor/magnific.js');

export function popup() {
  // var src = $('.popup--video').children('iframe').attr('src');
  $('.popupLink').magnificPopup({
    type: 'inline',
    midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    gallery: {
      enabled: true
    },
    callbacks: {
    open: function() {
      // $('.popup--video').children('iframe').attr('src', src);
      $('.cb-cursor').addClass('-close');
    },
    close: function() {
      $('.cb-cursor').removeClass('-close');
      // $('.popup--video').children('iframe').attr('src', '');
    }
  }
  });
}

export function promoPopup() {
  $('.popupTab a').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-promo',
    midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  });
}
